import { USAGE_CODES as USAGE_ENUMS } from '../PartsFormV3/types.d';
import { ProviderPartsFormV3Value } from './types';

export const RETURNABLE_YES = 'Yes' as const;
export const RETURNABLE_NO = 'No' as const;
export const RETURN_CARRIER_OTHER = 'other' as const;

export const isProviderPartsFormV3Valid = (
  data: ProviderPartsFormV3Value,
): boolean => {
  if (!data.usageCode) return false;
  if (!data.returnable) return false;

  if (
    data.returnable === RETURNABLE_YES &&
    data.usageCode !== USAGE_ENUMS.NOT_RECEIVED &&
    (!data.returnTracking?.trim() ||
      !data.returnCarrier?.trim() ||
      (data.returnCarrier === RETURN_CARRIER_OTHER && !data.returnCarrierOtherName?.trim()))
  ) return false;

  return true;
};
